<template>
  <div>
    <div class="plantht">
      <div class="planttxt" style="min-height: 500px">
        <h5 class="planth5"></h5>
        <div class="imgcontainer">

          <div class="container">
            <div class="left_part">
              <ul>
                <li
                  v-for="(item, index) in leftList"
                  :key="index"
                  @click="select(item.idx)"
                  :class="selectIndex == item.idx ? 'active' : ''"
                >
                  <a>{{ item.name }}</a>
                </li>
              </ul>
            </div>
            <div class="right_part" ref="box">
              <div v-if="showlist[0]">
                <p class="title" id="id1">1、开源因子库</p>
                <p><common-data name="appShortName_37"/>提供量价指标、财务指标、盈利预测、市场估值、持股结构等十几大类的133个开源因子。</p>
                 <Imggs :src="require('../../assets/img/kyyzk1.png')" alt="" @click.native="showimg(require('../../assets/img/kyyzk1.png'))" width="80%"/>
                <p>系统因子Python源代码的开放，可以帮助理解因子编写逻辑，也为自编因子提供完善的基础代码框架和编写示例。</p>
                 <Imggs :src="require('../../assets/img/kyyzk2.png')" alt="" @click.native="showimg(require('../../assets/img/kyyzk2.png'))" width="80%"/>
              </div>
              <div v-if="showlist[1]">
                <p class="title" id="id2">2、另类数据</p>
                <p>传统的量价类因子、财务类因子可能无法全面捕捉市场的动态和复杂性，稀缺独特的另类因子是投资者获取超额收益、不断提升业绩的致胜性因素。</p>
                <p>
                  目前，<common-data name="appShortName_37"/>提供以下三类另类数据，未来还将逐渐更新并提供更多的特色另类数据。
                </p>
                <p>
                  （1）事件驱动数据：
                </p>
                <p>通过政策、技术和社会面事件挖掘得到的事件概念基本面数据，可以及时提供精准的事件概念基本面信号捕捉能力，再结合其它常规因子可以获得更全面的市场信息、占据领先地位、制定更准确的选股策略。</p>
                <p>该数据可通过get_coverage_info函数调用。</p>
                <Imggs :src="require('../../assets/img/llsj1.png')" alt="" @click.native="showimg(require('../../assets/img/llsj1.png'))" width="80%"/>
                <p>
                  （2）股票市场法估值数据：
                </p>
                <p >
                  通过股票市场法估值数据可以获得更精准的股票估值水平信息。一方面可以通过低估值水平分析和构建中长期价值投资策略；另一方面也可以通过高估值水平精选市场关注度高、交易惯性强的股票，结合技术分析捕捉趋势机会，获取更高收益。
                </p>
                <p>
                  该数据可通过get_balanced_price函数调用。
                </p>
                <Imggs :src="require('../../assets/img/llsj2.png')" alt="" @click.native="showimg(require('../../assets/img/llsj2.png'))" width="80%"/>
                <p>
                  （3）日内统计数据：
                </p>
                <p >
                  通过tick、1分钟、15分钟、30分钟等高频分钟线数据挖掘得到的在日内具有高信息增益的数据，可以及时准确的捕捉市场动向、挖掘待涨股票，帮助用户制定更准确的选股策略。
                </p>
                <p>
                  该数据可通过get_intraday_statistics函数调用。 
                </p>
                <Imggs :src="require('../../assets/img/llsj3.png')" alt="" @click.native="showimg(require('../../assets/img/llsj3.png'))" width="80%"/>                
              </div>
              <div v-if="showlist[5]">
                <p class="title" id="id4">3、策略案例</p>
                <p><common-data name="appShortName_37"/>提供了市场中性、行业基本面量化、另类数据应用、可转债策略等多种策略构建案例、因子和数据的应用案例。</p>
                <p>案例的撰写和提供旨在于抛砖引玉，为软件的使用提供一些样本范例，也为因子、数据的应用提供一些思路或角度。</p>
                <p>未来，<common-data name="appShortName_37"/>也将与时俱进，及时更新进行更多案例的上传和更新。</p>
                <p>具体策略细节描述，详见【<common-data name="appShortName_37"/>-选股-案例】。</p>
                <Imggs :src="require('../../assets/img/al1.png')" alt="" @click.native="showimg(require('../../assets/img/al1.png'))" width="80%"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Baseimg :src='src' :show='ifimg' @change="ifimg=false"/>
  </div>
</template>

<script>
import Baseimg from '../view/frame/Baseimg.vue'
import Imggs from '../view/frame/Imggs.vue'
export default {
  components:{Baseimg,Imggs},
  data() {
    return {
      leftList: [
        // { name: "文华因子库" ,idx:0},
        { name: "开源因子库" ,idx:0},
        { name: "另类数据" ,idx:1},
        // { name: "行业轮动策略量化",idx:2 },
        // { name: "商品CTA策略" ,idx:3},
        // { name: "可转债策略量化" ,idx:7},
        // { name: "选择因子参考资料",idx:4 },
        { name: "策略案例 " ,idx:5},
      ],
      showlist: [true, false, false, false, false,false, false, false],
      selectIndex: 0,
      src:'',
      ifimg:false,
    };
  },
  methods: {
    select(index) {
      console.log(index)
      this.showlist.forEach((el, idx) => {
        this.showlist[idx] = false;
      });
      this.showlist[index] = true;
      this.selectIndex = index;
      // this.custormAnchor(`id${index + 1}`);
    },
    showimg(e){
      console.log(e)
      this.src=e
      this.ifimg=true
    },
    // custormAnchor(anchorName) {
    //   var target = document.getElementById(anchorName);
    //   if (target !== null) {
    //     this.$refs.box.scrollTop = target.offsetTop;
    //   }
    // },
  },
  mounted() {
    this.select(this.$route.params.id);
  },
};
</script>

<style scoped>
.packkua {
  width: 900px;
  margin: 0 auto;
  min-height: 0px;
  margin-top: 50px;
}
.packh4 {
  background: #f5e5e5;
  height: 25px;
}
.h4img {
  float: left;
  margin-top: -12px;
}
.imgcontainer {
  /* padding: 0 10px; */
  /* background: #f5f5f5; */
  border-left: 1px solid #f5f5f5;
  
}
.h4ti {
  width: 95px;
  border-radius: 0 0 30px 0;
  background: #e04a49;
  float: left;
  height: 25px;
  color: white;
  line-height: 24px;
  font-size: 16px;
  padding-left: 7px;
}
.kuatxt {
  padding: 20px 0 40px 0;
  width: 100%;
}
.kuatxt p {
  line-height: 25px;
  padding: 10px 0;
  font-size: 14px;
  text-indent: 2em;
  color: #6f6f6f;
  text-align: justify;
}
.plantht {
  min-height: 600px;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=53) no-repeat top;
  overflow: hidden;
}
.planttxt {
  width: 990px;
  border-radius: 5px;
  margin: 0 auto;
  margin-top: 236px;
  padding: 10px 30px 0 30px;
  background: white;

  box-shadow: 0 0 20px -5px #ccc;
}
.planth5 {
  font-size: 22px;
  color: #5f5f5f;
  /* border-bottom: 1px dashed #7f7f7f; */

  line-height: 40px;
}
.planth4 {
  background: #ffe9dc;
  height: 25px;
  width: 920px;
}
.h4ti1 {
  width: 111px;
  border-radius: 0 0 30px 0;
  background: #e0a180;
  float: left;
  height: 25px;
  color: white;
  line-height: 24px;
  font-size: 16px;
  padding-left: 7px;
}
.kuatxt p {
  width: 600px;
  line-height: 25px;
  text-align: justify;
}
.kuatxt {
  width: 600px;
  display: inline-block;
}
.imgs {
  display: inline-block;
  margin-left: 30px;
}
.imgtop div {
  color: #292929;
  text-indent: 2em;
  font-size: 15px;
  padding: 5px 0;
}
.container {
  width: 100%;
  position: relative;
  background: white;
  margin-top: 20px;
}
.right_part::-webkit-scrollbar {
  width: 0;
}
.left_part {
  display: inline-block;
  width: 259px;
  height: 100%;
  border-top: 1px solid #f5f5f5;
}
.left_part .title {
  width: calc(100% - 20px);
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  /* font-weight: bold; */
  background: url(../../assets/img/ts2.jpg) no-repeat center;
  background-size: 100% 100%;
  vertical-align: top;
  color: #fff;
  padding-left: 20px;
}
.left_part ul li {
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  font-size: 15px;
  color: #827373;
  border-bottom: 1px solid #ececec;
}
.left_part ul li:hover {
  color: #b56f6f;
}
.left_part ul li.active {
  background: #e57373;
  /* box-shadow: 2px 4px 4px #bebcbc inset; */
  color: white;
}
.left_part ul li a {
  width: 85%;
  margin: 0 auto;
  display: block;
  text-indent: 1em;
  position: relative;
}
.right_part {
  display: inline-block;
  width: 648px;
  height: 100%;
  vertical-align: top;
  background: #f5f5f5;
  padding: 20px 40px;
  color: #8a8a8a;
  /* box-shadow: -4px 4px 4px #bebcbc inset; */
  background: #efefef;
}
.right_part p {
  text-indent: 2em;
  padding: 5px 0;
  font-size: 14px;
  text-align: justify;
  line-height: 24px;
}
.right_part img {
  margin: 20px auto;
  display: block;
}
.right_part .title {
  font-size: 16px;
  font-weight: bold;
  text-indent: 0;
  color: #7e4040;
}
</style>